<template lang="jade">
  div.Input(v-bind:class="{'Input--filled': model, 'Input--invalid': schema.error, 'Input--valid': schema.complete }"
            ":skin"="skins.inputs")
    input.Input__field(":type"="schema.type"
                       ":id"="schema.id"
                       ":placeholder"="schema.placeholder"
                       v-model="model"
                       @focus="callbacks.focus"
                       @click="callbacks.click"
                       @keyup.38="callbacks.cycleUp"
                       @keyup.40="callbacks.cycleDown"
                       @keyup="callbacks.keyup"
                       @keydown.tab="callbacks.tabBefore"
                       @keyup.tab="callbacks.tabAfter"
                       ":disabled"="disabled"
                       ":readonly"="schema.readOnly"
                       ":name"="schema.name"
                       ":required"="schema.required")
    label.Input__label
      span.Input__label-content {{ schema.label }}
    div.Error(v-if="errors && config.inlineErrors" class="animated" transition="fade") 
      p.Error__msg {{ errors }}  
</template>

<script>
  import { skins } from 'src/vuex/getters'

  export default {
    data () {
      return {}
    },
    props: {
      model: {
        type: [String, Number],
        required: true
      },
      schema: {
        type: Object,
        coerce: x => {
          if (x.placeholder === undefined) {
            x.placeholder = ''
          }
          return x
        },
        required: true
      },
      callback: {
        type: Function
      },
      callbacks: {
        type: Object
      },
      errors: {
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    vuex: {
      getters: {
        skins
      }
    }
  }
</script>



// WEBPACK FOOTER //
// input.vue?a02e07aa